<template>
  <div>
    <div>1213112321312</div>
  </div>
</template>
<script>
export default {
  name: "Table",
};
</script>




// WEBPACK FOOTER //
// src/components/table/Table.vue